import React, { Component, createRef } from "react";
import { Director, View } from "@millicast/sdk";
import ReactSlider from "react-slider";
import "./Player-slider.css";
import UrlConstant from "../../helpers/UrlConstant";
import { CiTimer } from "react-icons/ci";
import Slider from "../../components/Slider";
import AudioButtons from "../../components/AudioButtons";
import { useNavigate } from "react-router-dom";

const audio = document.createElement("audio");
const audioCommentator = document.createElement("audio");

class PlayerSlider extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    const matchInfo = location?.state;

    this.millicastViewCommentator = null; //createRef();
    this.millicastView = null;
    this.streamName = null;
    this.streamAccountId = null;
    this.state = {
      username: "",
      password: "",
      errorMsg: "",
      type: "password",
      mId: "",
      ShowLoader: true,
      referContact: false,
      match: matchInfo,
      delayValue: 0,
      audioType: "referee",
      isPlaying: false,
      isLoading: 0,
    };
    this.audioContext = null;
    this.audioContextCommentator = null;
    this.delayNode = null;
    this.delayNodeCommentator = null;
    this.gainNode = null;
    this.gainNodeCommentator = null;
    this.maxDelay = 30; // max delay in seconds
  }
  componentDidMount() {
    if (!this.state.isPlaying) {
      this.loadStream();
      if (this.state.match?.milliCastCommentaryUrl) {
        setTimeout(() => {
          this.loadStreamCommentator();
        }, 1000);
      }
    }
  }

  componentWillUnmount() {
    // if (this.state.isPlaying) {
    this.stopStream();
    this.stopStreamCommentator();
    // }
  }

  loadStream = async () => {
    this.setState({ isLoading: 1 });
    const _href = new URL(this.state.match?.milliCastUrl);
    const _streamName = _href.searchParams.get("streamName");
    const _streamAccountId = _href.searchParams.get("streamAccountId");
    console.log("streamName", _streamName, "streamAccountId", _streamAccountId);

    const AudioContext = window.AudioContext;
    this.audioContext = new AudioContext();
    this.delayNode = this.audioContext.createDelay(30.0);
    this.delayNode.delayTime.value = this.state.delayValue;

    const tokenGenerator = () =>
      Director.getSubscriber({
        streamName: _streamName, //'l2a8e5y6',
        streamAccountId: _streamAccountId, //'4P2QPW'
      });
    // Create audio context
    // millicastView = null;
    this.millicastView = new View(_streamName, tokenGenerator, null);
    this.millicastView.on("track", ({ track }) => {
      // Ignore non audio tracks
      if (track.kind !== "audio") {
        return;
      }
      // this.delayNode.delayTime.value = this.state.delayValue;
      const stream = (window.stream = new MediaStream([track]));

      audio.srcObject = stream;
      audio.muted = true;
      audio.play();

      // Create media source
      var source = null;
      source = this.audioContext.createMediaStreamSource(stream);

      this.gainNode = this.audioContext.createGain();
      this.gainNode.gain.value = 0;

      // Creat primary graph, connect webrtc with the delay node and play it in the default destination
      source
        .connect(this.delayNode)
        .connect(this.gainNode)
        .connect(this.audioContext.destination);
      console.log(
        "this.delayNode.delayTime.value",
        this.delayNode.delayTime.value
      );
    });

    try {
      await this.millicastView.connect();
      this.setState({
        hasError: 0,
        isPlaying: true,
      });
      console.log("Stream connected successfully");
      if (this.gainNode.gain) {
        setTimeout(() => {
          this.gainNode.gain.value = 1;
          this.setState({
            isLoading: 0,
          });
        }, 1000);
      }
    } catch (error) {
      this.setState({ isLoading: 0, hasError: 1 });
      console.error("Error connecting to stream:", error);
    }
  };

  loadStreamCommentator = async () => {
    const _href = new URL(this.state.match?.milliCastCommentaryUrl);
    const _streamName = _href.searchParams.get("streamName");
    const _streamAccountId = _href.searchParams.get("streamAccountId");
    console.log(
      "streamName 1",
      _streamName,
      "streamAccountId 1",
      _streamAccountId
    );

    const AudioContext = window.AudioContext;
    this.audioContextCommentator = new AudioContext();
    this.delayNodeCommentator = this.audioContextCommentator.createDelay(30.0);
    this.delayNodeCommentator.delayTime.value = this.state.delayValue;

    const tokenGenerator = () =>
      Director.getSubscriber({
        streamName: _streamName, //'l2a8e5y6',
        streamAccountId: _streamAccountId, //'4P2QPW'
      });
    // Create audio context
    // millicastView = null;
    this.millicastViewCommentator = new View(_streamName, tokenGenerator, null);
    this.millicastViewCommentator.on("track", ({ track }) => {
      // Ignore non audio tracks
      if (track.kind !== "audio") {
        return;
      }
      const stream = (window.stream = new MediaStream([track]));

      audioCommentator.srcObject = stream;
      audioCommentator.muted = true;
      audioCommentator.play();

      // Create media source
      var source = null;
      source = this.audioContextCommentator.createMediaStreamSource(stream);

      this.gainNodeCommentator = this.audioContextCommentator.createGain();
      this.gainNodeCommentator.gain.value = 0;

      // Creat primary graph, connect webrtc with the delay node and play it in the default destination
      source
        .connect(this.delayNodeCommentator)
        .connect(this.gainNodeCommentator)
        .connect(this.audioContextCommentator.destination);
    });

    try {
      await this.millicastViewCommentator.connect();
      console.log("Stream connected successfully");
      this.setState({
        isPlaying: true,
        isLoading: 0,
        hasError: 0,
      });
    } catch (error) {
      this.setState({ isLoading: 0, hasError: 1 });
      console.error("Error connecting to stream:", error);
    }
  };

  stopStream = () => {
    if (audio && audio.srcObject) {
      const tracks = audio.srcObject.getTracks();
      tracks.forEach((track) => track.stop());

      audio.pause();
      audio.srcObject = null;
    }

    if (this.delayNode) {
      this.delayNode.disconnect();
    }

    if (this.millicastView) {
      this.millicastView.stop();
    }
  };

  stopStreamCommentator = () => {
    console.log("stopStream");

    if (audioCommentator && audioCommentator.srcObject) {
      const tracks = audioCommentator.srcObject.getTracks();
      tracks.forEach((track) => track.stop());

      audioCommentator.pause();
      audioCommentator.srcObject = null;
    }

    if (this.delayNodeCommentator) {
      this.delayNodeCommentator.disconnect();
    }

    if (this.millicastViewCommentator) {
      this.millicastViewCommentator.stop();
    }
  };

  // changeAudio = (type) => {
  //   console.log("type", type);
  //   if (this.state.isLoading != 0) {
  //     return;
  //   }
  //   if (!this.state.isPlaying) {
  //     this.setState({ isLoading: type === "commentator" ? 2 : 1 });
  //     if (this.state.audioType && type === "commentator") {
  //       this.loadStreamCommentator(type);
  //       setTimeout(() => {
  //         this.loadStream(type);
  //       }, 1000);
  //     } else {
  //       this.loadStream(type);
  //       setTimeout(() => {
  //         this.loadStreamCommentator(type);
  //       }, 1000);
  //     }
  //   } else {
  //     if (audioCommentator && audio) {
  //       if (type === "commentator") {
  //         audio.muted = true;
  //         audioCommentator.muted = false;
  //       } else {
  //         audio.muted = false;
  //         audioCommentator.muted = true;
  //       }
  //     }
  //     this.setState({ audioType: type });
  //   }
  // };

  changeAudio = (type) => {
    if (this.state.isLoading != 0) {
      return;
    }

    console.log(
      "2",
      "referee",
      this.gainNode.gain.value,
      "Commentator",
      this.gainNodeCommentator.gain.value
    );
    if (audioCommentator && audio) {
      if (type === "commentator") {
        console.log("3...........");
        this.gainNode.gain.value = 0;
        this.gainNodeCommentator.gain.value = 1;
        // console.log("3...........");
        // audio.muted = true;
        // audioCommentator.muted = false;
      } else {
        console.log("4...........");
        this.gainNode.gain.value = 1;
        this.gainNodeCommentator.gain.value = 0;
        // console.log("4...........");
        // audio.muted = false;
        // audioCommentator.muted = true;
      }
    }

    console.log(
      "5",
      "referee",
      this.gainNode.gain.value,
      "Commentator",
      this.gainNodeCommentator.gain.value
    );
    this.setState({ audioType: type });
  };

  // delayStream = (delay) => {
  //   if (this.delayNode) {
  //     if (this.audioContext.state === "suspended") {
  //       this.audioContext.resume();
  //     }
  //     this.delayNode.delayTime.setValueAtTime(
  //       delay,
  //       this.audioContext.currentTime
  //     );
  //   }

  //   this.setState({ delayValue: delay }, () => {
  //     console.log("State delayValue updated:", this.state.delayValue);
  //   });
  // };

  delayStream = (delay) => {
    if (this.state.isLoading != 0) {
      return;
    }
    if (this.state.audioType === "commentator") {
      if (this.delayNodeCommentator && this.audioContextCommentator) {
        if (this.audioContextCommentator.state === "suspended") {
          this.audioContextCommentator.resume();
        }
        this.delayNodeCommentator.delayTime.setValueAtTime(
          delay,
          this.audioContextCommentator.currentTime
        );
        console.log(
          "this.commentatorDelayNode.delayTime",
          this.delayNodeCommentator.delayTime
        );
      }
    } else {
      if (this.delayNode && this.audioContext) {
        if (this.audioContext.state === "suspended") {
          this.audioContext.resume();
        }
        this.delayNode.delayTime.setValueAtTime(
          delay,
          this.audioContext.currentTime
        );
        console.log("this.delayNode.delayTime", this.delayNode.delayTime);
      }
    }

    this.setState({ delayValue: delay }, () => {
      console.log("State delayValue updated:", this.state.delayValue);
    });
  };

  render() {
    const { match } = this.state;
    console.log("this.state.audioType", this.state.audioType);

    return (
      <div>
        <div
          style={{
            position: "absolute",
            top: 20,
            left: 20,
            zIndex: 1000,
          }}
        >
          <button
            onClick={() => this.props.navigate(-1)}
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#f5f5f5",
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "8px 16px",
              fontSize: "14px",
              color: "#333",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <span style={{ marginRight: "6px", fontSize: "16px" }}>←</span>
            Back
          </button>
        </div>
        <div className="match-content">
          {match.live && (
            <span className="live-badge">{match?.statusName}</span>
          )}
          <p className="large-match-subtitle">
            {match.title != null && match.title != ""
              ? match.title
              : match.poolName + " Match " + match.matchNumber}
          </p>
          <h2 className="match-title">
            <div className="large-team-logos">
              <img
                src={UrlConstant.thumbImageURL + match?.team1?.flag}
                alt={match?.team1?.abbrivation}
                className="large-team-logo"
              />
              <img
                src={UrlConstant.thumbImageURL + match?.team2?.flag}
                alt={match?.team2?.abbrivation}
                className="large-team-logo"
              />
            </div>
            {match?.team1?.abbrivation} v {match?.team2?.abbrivation}
          </h2>
          <p className="match-referee">
            <img
              src={UrlConstant.thumbImageURL + match?.refereePhoto}
              alt="Referee"
              className="referee-image"
            />
            {match?.refereeName}
          </p>

          {/* Venue */}
          <div className="match-venue">{match?.venueName}</div>
        </div>
        <div className="content login-main-wraper">
          <div className="container-fluid">
            <Slider
              delayValue={this.state.delayValue}
              delayStream={this.delayStream}
              isLoading={this.state.isLoading}
            />
            {match?.milliCastCommentaryUrl && (
              <AudioButtons
                audioType={this.state.audioType}
                changeAudio={this.changeAudio}
                isLoading={this.state.isLoading}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default PlayerSlider;
